<template>
  <div class="riskPointControl">
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: 'ProcessRiskPoint' }">风险点</el-breadcrumb-item>
        <el-breadcrumb-item>管控</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.query.id ? '新增' : '编辑' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" style="width: 60%;margin: auto" size="small">
        <el-form-item label="风险点" prop="riskClassificationId">
          <el-select v-model="ruleForm.riskClassificationId" style="width: 100%" :disabled="true">
            <el-option v-for="item in riskPointList" :key="item.id" :label="item.riskName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="所属部门" prop="depId">
          <el-select v-model="ruleForm.depId" style="width: 100%" :disabled="true">
            <el-option v-for="item in departList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="风险管控名称" prop="name">
          <el-input v-model="ruleForm.name" />
        </el-form-item>
        <el-form-item label="风险辨识" prop="riskIdentifyId">
          <el-select v-model="ruleForm.riskIdentifyId" style="width: 100%" @change="indentifyChange"
          :disabled="$route.params.data ? true : false">
            <el-option v-for="item in indentifyList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="作业步骤/排查项目" prop="riskControlMeasureId">
          <el-select v-if="$route.params.data ? false : true" v-model="ruleForm.riskControlMeasureId" style="width: 100%" @change="projectStepChange">
            <el-option v-for="item in projectAndStep" :key="item.id" :label="item.project" :value="item.id" />
          </el-select>
          <el-input v-else v-model="obj.project" disabled />
        </el-form-item>
        <el-form-item :label="analyticalMethodClassify === 1 ? '作业步骤' : '排查项目'">
          <el-input v-model="obj.project" disabled />
        </el-form-item>
        <el-form-item :label="analyticalMethodClassify === 1 ? '风险源、潜在事件' : '标准'">
          <el-input v-model="obj.name" disabled />
        </el-form-item>
        <el-form-item label="风险因素">
          <el-input v-model="obj.riskFactor" disabled />
        </el-form-item>
        <el-form-item :label="analyticalMethodClassify === 1 ? '可能发生的事故描述' : '不符合标准状况'">
          <el-input v-model="obj.riskDescription" disabled />
        </el-form-item>
        <el-form-item label="易发事故类型">
          <el-input v-model="obj.type" disabled />
        </el-form-item>
        <el-form-item label="危害描述">
          <el-input v-model="obj.consequence" disabled />
        </el-form-item>
        <div class="formbox_cont_title">管控措施</div>
        <el-form-item label="工程技术措施" prop="technicalMeasure">
            <el-input v-model="ruleForm.technicalMeasure" />
          </el-form-item>
          <el-form-item label="管理措施" prop="managementMeasure">
            <el-input v-model="ruleForm.managementMeasure" />
          </el-form-item>
          <el-form-item label="教育培训措施" prop="trainingMeasure">
            <el-input v-model="ruleForm.trainingMeasure" />
          </el-form-item>
          <el-form-item label="个人防护措施" prop="personalFenceMeasure">
            <el-input v-model="ruleForm.personalFenceMeasure" />
          </el-form-item>
          <el-form-item label="应急措施" prop="emergencyMeasure">
            <el-input v-model="ruleForm.emergencyMeasure" />
          </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 5px">
          <el-col :span="12">
            <el-form-item label="责任人" prop="responsibleEmpId">
              <el-select v-model="ruleForm.responsibleEmpId" style="width: 100%">
                <el-option v-for="item in userList" :key="item.id" :value="item.id" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="责任人电话" prop="responsiblePhone">
              <el-input v-model="ruleForm.responsiblePhone" />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 5px">
          <el-col :span="12">
            <el-form-item label="审核人" prop="auditEmpId">
              <el-select v-model="ruleForm.auditEmpId" style="width: 100%">
                <el-option v-for="item in userList" :key="item.id" :value="item.id" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="管控等级" prop="controlLevel">
              <el-select v-model="ruleForm.controlLevel" style="width: 100%">
                <el-option v-for="item in controlLevelList" :key="item.id" :value="item.id" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="" label-width="0">
          <el-col :span="12">
            <el-form-item label="下次评价时间" prop="nextEvaluateTime">
              <el-date-picker v-model="ruleForm.nextEvaluateTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="管控层级" prop="controlHierarchy">
              <el-select v-model="ruleForm.controlHierarchy" style="width: 100%">
                <el-option label="公司级" :value="0" />
                <el-option label="车间级" :value="1" />
                <el-option label="班组级" :value="2" />
                <el-option label="岗位级" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="">
          <el-button size="small" type="primary" style="width: 100%" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getStaffList, getAllDepartment, getRiskPointList, riskPointDetail, getIndentifyDangerList,
riskControlAdd, riskControlEdit } from "@/api/processManager"
export default {
  name: 'AddRiskPointControl',
  data() {
    return {
      ruleForm: {},
      // 存储分析方法分类 来控制下面的表格的表头显示
      analyticalMethodClassify: '',
      rules: {
        // riskClassificationId: [{ required: true, message: '请选择', trigger: 'blur' }],
        // depId: [{ required: true, message: '请选择', trigger: 'blur' }],
        riskIdentifyId: [{ required: true, message: '请选择' }],
        riskControlMeasureId: [{ required: true, message: '请选择', trigger: 'change' }],
        name: [{ required: true, message: '请选择' }],
        // project: [{ required: true, message: '请选择' }],
        // riskDescription: [{ required: true, message: '请选择' }],
        // type: [{ required: true, message: '请选择' }],
        // consequence: [{ required: true, message: '请选择' }],
        technicalMeasure: [{ required: true, message: '请选择' }],
        managementMeasure: [{ required: true, message: '请选择' }],
        trainingMeasure: [{ required: true, message: '请选择' }],
        personalFenceMeasure: [{ required: true, message: '请选择' }],
        emergencyMeasure: [{ required: true, message: '请选择' }],
        responsibleEmpId: [{ required: true, message: '请选择' }],
        responsiblePhone: [{ required: true, message: '请选择' }],
        auditEmpId: [{ required: true, message: '请选择' }],
        controlLevel: [{ required: true, message: '请选择' }],
        nextEvaluateTime: [{ required: true, message: '请选择' }],
        controlHierarchy: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      userList: [],
      riskPointList: [],
      departList: [],
      riskPointInfo: {},
      projectAndStep: [],
      // 风险辨识的列表
      indentifyList: [],
      // 选择作业步骤/排查项目之后回填的数据
      obj: {},
      controlLevelList: [
        { id: 0, name: '重大风险' },
        { id: 1, name: '较大风险' },
        { id: 2, name: '一般风险' },
        { id: 3, name: '低风险' }
      ]
    }
  },
  created() {
    this.getAllEmp();
    this.getDepart();
    this.getRiskPointList();
    // 新增
    if (this.$route.query.id) {
      getIndentifyDangerList(this.$route.query.id).then(res => {
        this.indentifyList = res.body.data;
        this.analyticalMethodClassify = Number(this.$route.query.status)
        this.$nextTick(() => {
          this.ruleForm.riskClassificationId = Number(this.$route.query.id)
          this.ruleForm.depId = this.$route.query.depId
          this.riskPointInfo = res.body.data
        })
      })
    // 编辑
    } else if (this.$route.params.data) {
      console.log(this.$route.params.data)
      getIndentifyDangerList(this.$route.params.data.riskClassificationId).then(res => {
        this.indentifyList = res.body.data;
        this.analyticalMethodClassify = Number(this.$route.params.data.status)
        let obj = this.$route.params.data
        this.$nextTick(() => {
          this.$set(this.ruleForm, 'id', obj.id)
          this.$set(this.ruleForm, 'riskClassificationId', obj.riskClassificationId)
          this.$set(this.ruleForm, 'depId', obj.depId)
          this.$set(this.ruleForm, 'riskIdentifyId', obj.riskIdentifyId)
          this.$set(this.ruleForm, 'name', obj.name)
          this.$set(this.ruleForm, 'riskControlMeasureId', obj.riskControlMeasureId)
          this.$set(this.obj, 'project', obj.measure.project)
          this.$set(this.obj, 'name', obj.measure.name)
          this.$set(this.obj, 'riskFactor', obj.measure.riskFactor)
          this.$set(this.obj, 'riskDescription', obj.measure.riskDescription)
          this.$set(this.obj, 'type', obj.measure.type)
          this.$set(this.obj, 'consequence', obj.measure.consequence)
          this.$set(this.ruleForm, 'technicalMeasure', obj.measure.technicalMeasure)
          this.$set(this.ruleForm, 'managementMeasure', obj.measure.managementMeasure)
          this.$set(this.ruleForm, 'trainingMeasure', obj.measure.trainingMeasure)
          this.$set(this.ruleForm, 'personalFenceMeasure', obj.measure.personalFenceMeasure)
          this.$set(this.ruleForm, 'emergencyMeasure', obj.measure.emergencyMeasure)
          this.$set(this.ruleForm, 'responsibleEmpId', obj.responsibleEmpId)
          this.$set(this.ruleForm, 'responsiblePhone', obj.responsiblePhone)
          this.$set(this.ruleForm, 'auditEmpId', obj.auditEmpId)
          this.$set(this.ruleForm, 'controlLevel', obj.controlLevel)
          this.$set(this.ruleForm, 'nextEvaluateTime', obj.nextEvaluateTime)
          this.$set(this.ruleForm, 'controlHierarchy', obj.measure.controlHierarchy)
          this.riskPointInfo = res.body.data
        })
      })
    }
  },
  methods: {
    // 获取分险点数据
    getRiskPointList() {
      getRiskPointList({ limit: 1000, curPage: 1 }).then(res => {
        this.riskPointList = res.body.data;
      })
    },
    // 获取所有员工
    getAllEmp() {
      getStaffList().then(res => {
        this.userList = res.body.data;
      })
    },
    // 获取所有部门的列表
    getDepart() {
      getAllDepartment().then(res => {
        this.departList = res.body.data
      })
    },
    // 风险辨识改变
    indentifyChange(val) {
      this.$set(this.ruleForm, 'riskControlMeasureId', '')
      this.obj.project = '';
      this.obj.name = '';
      this.obj.riskFactor = '';
      this.obj.riskDescription = '';
      this.obj.type = '';
      this.obj.consequence = '';
      for(let i in this.indentifyList) {
        if(val === this.indentifyList[i].id) {
          this.projectAndStep = this.indentifyList[i].measure
          this.ruleForm.responsibleEmpId = this.indentifyList[i].responsibleEmpId
          this.ruleForm.responsiblePhone = this.indentifyList[i].responsiblePhone
          this.ruleForm.auditEmpId = this.indentifyList[i].auditEmpId
        }
      }
    },
    // 作业步骤、排查项目下拉框改变
    projectStepChange(val) {
      for(let i in this.projectAndStep) {
        if(val === this.projectAndStep[i].id) {
          this.obj = { ...this.projectAndStep[i] }
          this.$set(this.ruleForm, 'controlLevel', this.obj.riskLevel)
        }
      }
      this.$forceUpdate();
    },
    // 保存
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          // 新增
          if(this.$route.query.id) {
            riskControlAdd({ ...this.ruleForm }).then(res => {
              this.$message.success('保存成功');
              this.$router.push({
                path: 'twoOrderNew',
                query: { status: 'second' }
              });
            })
          // 编辑
          } else if(this.$route.params.data) {
            riskControlEdit({ ...this.ruleForm }).then(res => {
              this.$message.success('保存成功');
              this.$router.push({
                path: 'twoOrderNew',
                query: { status: 'second' }
              });
            })
          }
        } else {
          return false;
        }
      })
    }
  }
}
</script>

<style scoped>
 .riskPointControl /deep/ .el-input.is-disabled .el-input__inner {
  color: #666666;
}
</style>